/**
 * Patients and family (WP1-PATIENTS, BUILD-PLAN M04). Replaces the shell's
 * Patients placeholder: the search page at `/patients` and the patient
 * record at `/patients/$patientId` (other WPs add their own tabs as routes
 * under it). Also registers the blind-index patient search provider for the
 * command palette (Ctrl+K and `/`).
 */
import { defineManifest } from '@velora/contracts';
import { defineWebModule } from '../../app/module.js';
import { installPatientSearch } from './search-provider.js';

installPatientSearch();

export default defineWebModule({
  manifest: defineManifest({
    id: 'patients',
    title: 'Patients',
    version: '0.2.0',
    owner: 'WP1-PATIENTS',
    entitlementKey: null,
    permissions: ['patient.view', 'patient.edit', 'money.view'],
    routes: [
      {
        id: 'list',
        path: '/patients',
        title: 'Patients',
        officeScope: 'location-or-all',
        permission: 'patient.view',
        readsPhi: true,
      },
      {
        id: 'record',
        path: '/patients/$patientId',
        title: 'Patient',
        officeScope: 'location-or-all',
        permission: 'patient.view',
        readsPhi: true,
      },
      {
        // Distribution by office, weekly movement, recent drops (names: PHI).
        id: 'grades',
        path: '/patient-grades',
        title: 'Patient grades',
        officeScope: 'location-or-all',
        permission: 'patient.view',
        readsPhi: true,
      },
    ],
    nav: [
      {
        label: 'Patients',
        labelKey: 'familyFile',
        group: 'patients',
        routeId: 'list',
        icon: 'users-round',
        order: 10,
      },
      {
        label: 'Patient grades',
        group: 'patients',
        routeId: 'grades',
        icon: 'trending-up',
        order: 12,
        permission: 'patient.view',
      },
    ],
    commands: [
      {
        id: 'patients.open',
        title: 'Go to Patients',
        keywords: ['family', 'household', 'records', 'search'],
        routeId: 'list',
      },
      {
        id: 'patients.grades',
        title: 'Patient grades overview',
        keywords: ['grade', 'grades', 'grading', 'reliability', 'no-show', 'dropped', 'a b c d f'],
        routeId: 'grades',
        permission: 'patient.view',
      },
    ],
    shortcuts: [{ keys: 'g p', description: 'Go to Patients', routeId: 'list' }],
    sseEntityKeys: ['patient'],
    phiReadPoints: ['patient.search', 'patient.open', 'patient.timeline'],
  }),
  pages: {
    list: () => import('./PatientsPage.js'),
    record: () => import('./PatientPage.js'),
    grades: () => import('./grade/GradesOverviewPage.js'),
  },
});
